<div class="dialog">
  <div mat-dialog-title
       class="dialog-title">
    <h1>{{ 'global.dialogs.confirmation.title' | translate }}</h1>
  </div>
  <div mat-dialog-content
       class="dialog-content">
    <p>{{ 'global.dialogs.confirmation.content' | translate }}</p>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions
       class="dialog-actions">
    <button mat-raised-button
            color="primary"
            (click)="onConfirm()">
      {{ 'global.dialogs.confirmation.buttons.yes' | translate }}
    </button>
    <button mat-stroked-button
            (click)="onDismiss()">
      {{ 'global.dialogs.confirmation.buttons.no' | translate }}
    </button>
  </div>
</div>